const NAMESPACE = 'shortcut';

export const Funcs = {
    // 打开系统文件选择器上传文件
    OpenFilePicker: `open-file-picker`,
    // 打开「我的图片」
    OpenMyImagesModal: `open-my-images-modal`,
    // 打开「图片图库」
    OpenPicturePanel: `open-picture-panel`,
    // 打开「添加背景」
    OpenBackgroundPanel: `open-background-panel`,
    // 添加文字图层
    AddTextLayer: `add-text-layer`,
    // 打开文字素材面板
    OpenTextPanel: `open-text-panel`,
    // 添加矢量图层
    AddVectorLayer: `add-vector-layer`,
    // 添加画笔图层
    AddBrushLayer: `add-brush-layer`,
    // 打开画图面板
    OpenDrawPanel: `open-draw-panel`,
    // 使用画笔
    UseDrawTool: `use-draw-tool`,
    // 使用素材
    UseMaterial: `use-material`,
    // 打开素材面板
    OpenMaterialPanel: `open-material-panel`,
    // 打开表格面板
    OpenTablePanel: `open-table-panel`,
    // 打开二维码面板
    OpenQrCodePanel: `open-qrcode-panel`,
    // 使用水印
    UseWatermark: `use-watermark`,
    // 打开水印面板
    OpenWatermarkPanel: `open-watermark-panel`,
} as const;

export const ScopeEvents = {
    /**
     * shortcut-collapse 面板功能使用广播事件
     * ATTENTION:
     *  - Q：为什么有该事件？
     *    A：因为 shortcut-collapse 面板中有使用画笔工具的功能，在使用其他工具，需要取消画笔工具的使用状态
     */
    FuncUse: `${NAMESPACE}/func-use`,
} as const;
